<template>
  <div class="tabs" ref="myTabs">
    <div class="scroll-container">
      <el-tag v-for="(item, index) in tags" :key="item.name" :id="item.name" :closable="item.name !== 'home'"
        :disable-transitions="true" :effect="$route.name === item.name ? 'dark' : 'plain'" @click="changeMenu(item)"
        @close="handleClose(item, index)" size="Medium">
        <span :class="$route.name === item.name ? 'tag-active' : ''"></span> {{ $t(item.label) }}
      </el-tag>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "commonTag",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      tags: (state) => state.tab.tabList,
      breadcrumbList: (state) => state.tab.breadcrumbList,
      nextLabel: (state) => state.tab.next_label,
    }),
    // 導航主題
    nav_theme() {
      return this.$store.getters.current_nav_theme.background === undefined ? { "background": "#3c8dbc", "color": "#fff" } : this.$store.getters.current_nav_theme;
    },
    //  菜單主題
    menu_theme() {
      return this.$store.getters.current_menu_theme.background === undefined ? { "background": "#304156", "color": "rgb(191, 203, 217)" } : this.$store.getters.current_menu_theme;
    },
    //  菜單主題
    body_theme() {
      return this.$store.getters.current_body_theme.background === undefined ? { "background": "#ffffff", "color": "#606266" } : this.$store.getters.current_body_theme;
    },
    body_theme_striped() {
      return this.$store.getters.current_body_theme_striped.background === undefined ? { "background": "#6c757d", "color": "#fff" } : this.$store.getters.current_body_theme_striped;
    },
  },
  methods: {
    ...mapMutations(["closeTag"]),
    scrollTo(selector) {
      const element = document.querySelector(selector)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    // 跳轉最右側
    scrollToEnd() {
      window.scrollTo(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER) // 滚动到最右侧
    },
    // 点击tag跳转的功能
    changeMenu(item) {
      const index = this.tags.findIndex((val) => val != null && val.name === item.name);
      if (index === -1)
        this.scrollToEnd()
      else
        this.scrollTo(`#${item.name}`)
      // 增加頁面緩存
      if (this.$route.meta != undefined && this.$route.meta.istrun) {
        this.$store.dispatch('addCachedView', this.$route)
      }
      this.routePush(item, "");
      const del_index = this.breadcrumbList.findIndex(
        (item) => item.name !== "home"
      );
      // 处理更改选项卡动态更新面包屑
      if (del_index != -1) {
        this.breadcrumbList.splice(del_index, 1);
      }
      if (item.name != "home") {
        this.breadcrumbList.push(item);
      }
      this.$store.commit("get_current_label", item.label);
      if (this.IsMobile() != null) {
        this.$store.state.tab.isCollapse = true;
      }
    },
    //  点击tag删除的功能
    handleClose(item, index) {
      //调用mapMutations的closeTag 或者this.$store.commit
      this.closeTag({ item: item, type: 1 });
      const length = this.tags.length;
      // 删除之后的跳转逻辑
      if (item.name !== this.$route.name) {
        //路由不等光标位置就不变
        return;
      }
      else {
        // 清除当前路由m_code
        this.$store.commit('get_tab_code', "")
      }
      if (index === length) {
        //如果相等 就左移
        this.routePush(this.tags[index - 1], this.tags[index - 1].name);
      } else {
        this.routePush(this.tags[index], this.tags[index].name);
      }
      // 处理移除tag时，同时更新面包屑
      if (this.tags.length >= 1) {
        const del_index = this.breadcrumbList.findIndex(
          (item) => item.name !== "home"
        );
        this.breadcrumbList.splice(del_index, 1);
        if (this.tags[this.tags.length - 1].name != "home") {
          this.breadcrumbList.push(this.tags[this.tags.length - 1]);
        }
      }
    },
    // 路由參數跳轉
    routePush(item, name) {
      // 通过路由name或者地址跳转
      // 如果为undefined时为列表页
      if (item.params === undefined) {
        this.$router.push({ name: name != "" ? name : item.name, params: { type: item.type, right: (item.acode || "") } });
      }
      else
      // 切换修改页面需带参
      {
        if (item.params.actione_type === "add") {
          this.$router.push({ name: name != "" ? name : item.name, params: { actione_type: item.params.actione_type, LookupType: item.params.LookupType, right: (item.acode || "") } });
        }
        else {
          this.$router.push({ name: name != "" ? name : item.name, params: { actione_type: item.params.actione_type, id: item.params.id, sTable_name: item.params.sTable_name, LookupType: item.params.LookupType, right: (item.acode || "") } });
        }
      }
    },

    set_theme(obj) {
      var container = this.$refs.myTabs;
      //container.style.backgroundColor = this.nav_theme["background"];
      //container.style.color = this.nav_theme["color"];
      var element = container.querySelectorAll(obj);
      for (var i = 0; i < element.length; i++) {
        if (this.nav_theme["background"] != "rgb(255, 255, 255)")
          element[i].style.backgroundColor = this.nav_theme["background"];
        element[i].style.color = this.nav_theme["color"];
      }

      var element = container.querySelectorAll(".el-tag--plain");
      for (var i = 0; i < element.length; i++) {
        //element[i].style.backgroundColor = "";
        element[i].style.color = "black";
      }
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   // 选项卡主题
    //   this.set_theme(".el-tag--dark");
    // });
  },
  updated() {
    this.SetFontSize(this.$store.getters.size);
    this.$nextTick(() => {
      // 选项卡主题
      this.set_theme(".el-tag--dark");
    });
  },
  watch: {
    // 處理路由切換緩存失效問題
    $route() {
      // 处理动态路由多语言拼接
      /* if (this.$route.params != undefined && this.$route.params.actione_type != "") {
        var item = this.$store.state.tab.tabList.filter(item => item.name === this.$route.name)[0];
        if (this.$route.params.actione_type === "add")
          item.label = this.$t(item.label).replace("[" + this.$t('_new') + "]","") + "[" + this.$t('_new') + "]"
        else if (this.$route.params.actione_type === "edit")
          item.label = this.$t(item.label).replace("[" + this.$t('_edit') + "]", "") + "[" + this.$t('_edit') + "]"
        else if (this.$route.params.actione_type === "V")
          item.label = this.$t(item.label).replace("[" + this.$t('_view') + "]", "") + "[" + this.$t('_view') + "]"
      } */
      setTimeout(() => {
        var items = this.$store.state.tab.tabList.filter(item => item.name === this.$route.name);
        items.length > 0 && this.changeMenu(items[0]);
      }, 0);
    },
    nextLabel: {
      handler(val) {
        if (val) {
          var tag = this.tags.filter(item => item.name === val || item.name === val + '_edit');
          if (tag.length > 0) {
            this.changeMenu(tag[0]);
          }
        }
      }
    },
  }
};
</script>
<style lang="less" scoped>
.tabs {
  padding-left: 8px;
  height: 42px; //默認34px
  //width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  display: flex;
  align-items: flex-end;
  padding-bottom: 3px;

  .el-tag {
    margin-right: 5px;
    cursor: pointer;
    border-radius: 0;
  }

  .tag-active {
    content: "";
    background: #fff;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: relative;
    bottom: 2px;
  }

  .el-tag--dark {
    background-color: rgb(60, 141, 188);
    ;
    border-color: rgb(60, 141, 188);
    ;
  }

  .el-tag--plain {
    border: 1px solid #d8dce5;
    color: #495060;
  }

  // 关闭选项卡样式
  /deep/.el-icon-close {
    width: 32px;
    height: 30px;
    line-height: 30px;
    border-radius: 100%;
    position: relative;
    top: 0px;
    font-size: 20px;
    vertical-align: baseline;
    text-align: center;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform-origin: 100% 50%;

    &:hover {
      background-color: #b4bccc;
      color: #fff;
    }
  }

  /deep/.el-tag--plain .el-tag__close {
    color: #495060;
  }

  .scroll-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    overflow: auto;

  }
}


// 移除選項卡y軸滾動
/deep/.el-scrollbar__bar.is-vertical>div {
  width: 0%;
}

::-webkit-scrollbar {
    /*滾動條整體樣式*/
    width: 1px !important; /*高寬分別對應橫豎滾動條的尺寸*/
    height: 5px;
}

::-webkit-scrollbar-thumb {
    /*滾動條裏面小方塊*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
}

::-webkit-scrollbar-track {
    background-color: #f6f6f6;
}
::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
    border: 0;
}
</style>
